import { cva, type VariantProps } from "class-variance-authority";
import { AnimatePresence, motion } from "framer-motion";
import { useModalCloseEffect } from "../../hooks/useModalCloseEffect";
import { cn } from "../../utils/cn.utils";

export const ModalVariants = cva(
  "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg w-auto flex flex-col",
  {
    variants: {
      variant: {},
      size: {
        default: "min-w-[468px] max-w-[80%] rounded",
        fitheight: "w-full max-w-[468px] sm:max-w-[calc(100%-40px)] mx-auto rounded",
        mobile: "w-full max-w-[calc(100%-40px)] mx-auto rounded h-[80%] ",
        full: "w-full h-full",
        dialog: "w-full mx-auto md:w-[304px] sm:max-w-[calc(100%-64px)] sm:min-w-[250px] rounded-[16px]",
      },
    },
    defaultVariants: {
      size: "default",
    },
  }
);

interface Props
  extends React.ComponentProps<"div">,
  VariantProps<typeof ModalVariants> {
  enableOutsideClick?: boolean;
  children?: React.ReactNode;
  close?: () => void;
}

export default function Modal({
  size,
  close,
  enableOutsideClick = true,
  className,
  children,
}: // ...props
  Props) {
  const { wrapperRef, handleOutsideClick } = useModalCloseEffect({
    onClose: close,
    enableOutsideClick: enableOutsideClick,
  });

  return (
    <AnimatePresence>
      <motion.div
        ref={wrapperRef}
        onClick={handleOutsideClick}
        className="fixed inset-0 z-1500 bg-black/40"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.05, ease: "easeOut" }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.05, ease: "easeOut" }}
          className={cn(ModalVariants({ size }), className)}
          onClick={(e) => e.stopPropagation()}
        // {...props}
        >
          {children}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
